import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import './Profile.css';
import useTracking from '../../hooks/useTracking';
import PaymentService from '../../services/paymentService';
import ChariowPhoneModal from '../Payment/ChariowPhoneModal';

const FullScreenSpinner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #FF50A2;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const InvitationsOffcanvas = ({ show, onClose }) => {
  const tracking = useTracking();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(5);
  const [isLoading, setIsLoading] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const authState = useSelector(state => state.auth);
  const savedPhoneNumber = authState.numero || authState.phoneNumber || '';
  const invitationOptions = [
    { amount: 5, price: '5000',id:"5invit" },
    { amount: 10, price: '9000',id:"10invit" },
    { amount: 30, price: '25000',id:"30invit" }
  ];

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      setTimeout(() => setIsVisible(true), 50);
    } else {
      setIsVisible(false);
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  const handlePurchase = () => {
    setShowPhoneModal(true);
  };

  const submitPurchase = async (paymentPhoneNumber) => {
    try {
      const selectedPackage = invitationOptions.find(opt => opt.amount === selectedOption);
      
      // Close the offcanvas
      // onClose();
        setIsLoading(true);
        
        // Initier le paiement via Chariow
        const result = await PaymentService.initiateChariowPayment(
          selectedPackage.id,
          paymentPhoneNumber,
          tracking.getAttributionData()
        );
        
        if (result.step === 'payment' && result.paymentUrl) {
          tracking.trackAction('subscription_initiated', {
            type:'invitations',
            nombre: selectedOption,
            price: selectedPackage.price,
            provider: 'chariow'
          });
          window.location.href = result.paymentUrl;
        } else if (result.step === 'completed') {
          tracking.trackAction('subscription_completed', {
            type: 'invitations',
            nombre: selectedOption,
            provider: 'chariow'
          });
          window.location.href = '/payment/success';
        } else if (result.step === 'already_purchased') {
          console.info('Pack deja achete:', selectedPackage.id);
        }
      } catch (error) {
        console.error('Erreur lors de l\'initiation du paiement Chariow:', error);
      } finally {
        setIsLoading(false);
        setShowPhoneModal(false);
      }
  };

  if (!show) return null;

  const content = (
    <div className="offcanvas-wrapper">
      {isLoading && (
        <FullScreenSpinner>
          <div className="spinner" />
        </FullScreenSpinner>
      )}
      <div 
        className={`offcanvas-backdrop ${isVisible ? 'show' : ''}`} 
        onClick={onClose}
      ></div>
      <div className={`subscription-offcanvas ${isVisible ? 'show' : ''}`}>
        <div className="offcanvas-header">
          <div className="offcanvas-title">
            <div className="offcanvas-icon invitations">
              <i className="icon feather icon-star"></i>
            </div>
            <div className="offcanvas-title-text">
              <div className="title">{t('invitations.title')}</div>
              <div className="subtitle">{t('invitations.subtitle')}</div>
            </div>
          </div>
          <button className="close-button" onClick={onClose}>
            <i className="icon feather icon-x"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="super-like-options">
            {invitationOptions.map(({ amount, price }) => (
              <div 
                key={amount} 
                className={`option-box ${selectedOption === amount ? 'active' : ''} invitations`}
                onClick={() => setSelectedOption(amount)}
              >
                <div className="option">
                  <div className="number">{amount}</div>
                  <span className="text">{t('invitations.credits')}</span>
                  <div className="price">{t('invitations.price', { price: price.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') })}</div>

                </div>
              </div>
            ))}
          </div>
          <button className="btn-gradient invitations" onClick={handlePurchase}>
          {t('invitations.purchase')}
          </button>
        </div>
      </div>
      <ChariowPhoneModal
        show={showPhoneModal}
        defaultPhoneNumber={savedPhoneNumber}
        loading={isLoading}
        onCancel={() => !isLoading && setShowPhoneModal(false)}
        onConfirm={submitPurchase}
      />
    </div>
  );

  return ReactDOM.createPortal(content, document.body);
};

export default InvitationsOffcanvas;
